import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  invoicesListHeader: {
    backgroundColor: '#f5f5f5',
    marginHorizontal: -20,
    padding: 20,
    flexDirection: 'row',
    marginBottom: 20,
  },
  payInvoiceHeader: {
    paddingVertical: 20,
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#E6EBEE',
    marginBottom: 14,
  },
})
